import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { SuggestionDiscountSettings } from "../../recommendation.types";
import { requestGetSuggestionDiscountSettings } from "./getSuggestionDiscountSettings.request";

const useSuggestionDiscountSettings = (
  options?: QueryOptions<
    SuggestionDiscountSettings,
    ApiServiceError<ApiError>
  >
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["recommendation", "suggestionDiscount", "settings"],
    queryFn: async () => await requestGetSuggestionDiscountSettings(),
    onError: toastServerError,
    ...options
  });

  return { settings: data, ...rest };
};

export default useSuggestionDiscountSettings;
